import React from "react";
import {autobind} from "core-decorators";
import {Button, Tooltip} from "antd";
import {FaFolderOpen} from "react-icons/fa";
import {Link} from "react-router-dom";
import {observer} from "mobx-react";

import {CorrectPieceStatuses} from "@/shared/constants";
import {paths} from "@/routes";
import {PiecesQuery} from "@/graphql/types";
import Store from "@/stores";

export interface IOpenPiecesActionProps {
  piece: PiecesQuery["pieces"][0];
  store?: Store;
}

@autobind
@observer
export default class OpenPieceAction extends React.Component<IOpenPiecesActionProps> {
  public render() {
    const {piece} = this.props;
    const openable = CorrectPieceStatuses.find((status) => status === piece.status);
    return (
      <Tooltip title="Open" placement="topLeft" arrowPointAtCenter>
        {openable ? (
          <Link to={paths.piece(piece.id)}>
            <Button className="open-btn" type="link" shape="circle" size="small">
              <FaFolderOpen />
            </Button>
          </Link>
        ) : (
          <Button className="open-btn" type="link" shape="circle" size="small" disabled>
            <FaFolderOpen />
          </Button>
        )}
      </Tooltip>
    );
  }
}
